import React from "react";
import { useNode } from "@craftjs/core";
import styled from "@emotion/styled";
import { useState } from "react";

const SectionGroup = styled.div`
  padding: 10px 15px;
  box-shadow: 0 1px 0 var(--builder-option-border-color);

  :focus {
    outline: none;
  }
`;

interface ISectionGroupProps {
  collapsed: boolean;
}
const SectionGroupHeader = styled.div<ISectionGroupProps>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  color: var(--builder-text-color);

  .collapsed {
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-top-color: var(--builder-text-color);
    border-width: 6px 4px 0 4px;
    ${(props) => (props.collapsed ? "transform: rotate(-90deg);" : "")}
  }

  .title {
    display: flex;
    align-items: center;
    padding: 5px 0;
  }

  .title-text {
    margin-right: 10px;
  }
  .addons {
    display: flex;
    align-items: center;
    opacity: 0.4;
  }
`;

const SectionGroupContent = styled.div<ISectionGroupProps>`
  margin-top: 10px;
  padding: 0 0 10px;
  display: ${(props) => {
    return props.collapsed ? "none" : "block";
  }};
`;

export interface IToolbarSectionProps {
  title: string;
  summary?: any;
  props?: any[];
  defaultOpen?: boolean;
  actions?: React.ReactNode;
}

export const ToolbarSection: React.FC<
  React.PropsWithChildren<IToolbarSectionProps>
> = ({ title, props, summary, defaultOpen, actions, children }) => {
  const [collapsed, setCollapse] = useState<boolean>(!defaultOpen);

  const { nodeProps } = useNode((node) => ({
    nodeProps:
      props &&
      props.reduce((res: any, key: any) => {
        res[key] = node.data.props[key] || null;
        return res;
      }, {}),
  }));
  return (
    <SectionGroup>
      <SectionGroupHeader
        collapsed={collapsed}
        onClick={() => {
          setCollapse(!collapsed);
        }}
      >
        <div className="title">
          <span className="title-text">{title}</span>
          <span className="collapsed"></span>
        </div>
        {summary && props ? (
          <div className="addons">
            <span>
              {summary(
                props.reduce((acc: any, key: any) => {
                  acc[key] = nodeProps[key];
                  return acc;
                }, {})
              )}
            </span>
          </div>
        ) : null}
        {actions && <div className="addons">{actions}</div>}
      </SectionGroupHeader>
      <SectionGroupContent collapsed={collapsed}>
        {children}
      </SectionGroupContent>
    </SectionGroup>
  );
};
